// ============================================================
// data/roadmap.ts — Estado factual do programa Lume
// ============================================================
// Sem datas comprometidas — calendário CEP-CONEP é externo.
// "Estado": done | active | planned.
// ============================================================

export interface Milestone {
  id: string;
  label: string;
  short: string;
  state: 'done' | 'active' | 'planned';
  body: string;
}

export const roadmap: ReadonlyArray<Milestone> = [
  {
    id: 'm0',
    label: 'M0',
    short: 'Fundação',
    state: 'done',
    body:
      'Constituição do programa, 9 ADRs ratificados, 6 docs de ética, 3 docs clínicos, 4 docs UX, schemas Zod + perfis FHIR R5 e Security Rules ≥ 95% cobertura.',
  },
  {
    id: 'm1',
    label: 'M1',
    short: 'Backend core',
    state: 'done',
    body:
      'Cloud Functions com auth, paciente, eventos, LGPD callables. Cobertura ≥ 90%. Auditoria validada por logAuditEvent em todas as operações.',
  },
  {
    id: 'm2',
    label: 'M2',
    short: 'IA + clínico',
    state: 'active',
    body:
      'Motor de IA clínica integrado. Sumarização, história social, chat texto, prescrição com drug-interactions. Conversação ao vivo restrita a 3 cenários permitidos.',
  },
  {
    id: 'm3',
    label: 'M3',
    short: 'PWA frontend',
    state: 'done',
    body:
      'Telas adaptativas N1/N2/N3, cuidador, painel médico, CAA, Modo Calma, Modo Crise, Modo Distração com 5 stim toys digitais.',
  },
  {
    id: 'm4',
    label: 'M4',
    short: 'Painel médico',
    state: 'active',
    body:
      'Lista priorizada virtualizada (TanStack), prontuário vivo com timeline, teleconsulta WebRTC P2P, indicador de fonte de dados.',
  },
  {
    id: 'm5',
    label: 'M5',
    short: 'Wearable + Predict',
    state: 'active',
    body:
      'Polar H10 via Web Bluetooth + simulador paralelo. TF.js predict on-device com calibração pessoal. Fallback iOS comportamental.',
  },
  {
    id: 'm6',
    label: 'M6',
    short: 'Conformidade + E2E',
    state: 'planned',
    body:
      'Lighthouse CI bloqueante, Playwright E2E em 12+ jornadas críticas, red-team IA com 200+ cenários. Auditoria axe-core em todo PR.',
  },
  {
    id: 'm7',
    label: 'M7',
    short: 'Piloto alfa → beta',
    state: 'planned',
    body:
      'Alfa fechado com 8–12 famílias internas. Beta SUS com 30–50 pacientes em 2–3 clínicas, 4–6 semanas de uso efetivo.',
  },
  {
    id: 'm8',
    label: 'M8',
    short: 'Estudo CEP-CONEP',
    state: 'planned',
    body:
      'Estudo controlado: 120 pacientes randomizados estratificadamente. Desfecho primário: redução ≥ 25% na frequência semanal de crises sensoriais.',
  },
];
